(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3767],{

/***/ 63144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgGoogle(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M5.018 12c0-.762.13-1.493.36-2.178L1.34 6.802A11.528 11.528 0 00.11 12c0 1.868.442 3.63 1.228 5.194l4.036-3.025A6.81 6.81 0 015.018 12",
    fill: "#FBBC05"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.11 5.067c1.69 0 3.217.586 4.417 1.546L20.018 3.2C17.891 1.387 15.164.267 12.11.267c-4.742 0-8.818 2.655-10.77 6.535l4.04 3.02c.93-2.766 3.582-4.755 6.73-4.755",
    fill: "#EA4335"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.11 18.933c-3.149 0-5.801-1.989-6.732-4.755l-4.038 3.02c1.951 3.88 6.027 6.535 10.77 6.535 2.926 0 5.72-1.017 7.818-2.924l-3.834-2.902c-1.081.667-2.443 1.026-3.985 1.026",
    fill: "#34A853"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M23.564 12c0-.693-.11-1.44-.273-2.133H12.109V14.4h6.436c-.321 1.546-1.197 2.734-2.45 3.507l3.833 2.902c2.203-2.002 3.636-4.984 3.636-8.809",
    fill: "#4285F4"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgGoogle);

/***/ }),

/***/ 17649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgLogoText(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 120,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M34.102 5.63c1.906 0 3.318.41 4.236 1.231.918.821 1.41 2.072 1.478 3.754l-4.268.737c.068-.816-.089-1.43-.471-1.844-.382-.412-.962-.619-1.738-.619-1.031 0-1.944.356-2.738 1.07-.794.712-1.401 1.904-1.822 3.576-.468 1.858-.487 3.17-.057 3.937.431.767 1.172 1.15 2.223 1.15.786 0 1.486-.223 2.1-.67.614-.448 1.161-1.217 1.643-2.308l3.893.693c-.894 1.868-2.06 3.279-3.499 4.232-1.439.954-3.165 1.431-5.18 1.431-2.289 0-3.932-.723-4.928-2.168-.997-1.445-1.173-3.446-.529-6.002.652-2.586 1.842-4.6 3.57-6.04 1.73-1.44 3.758-2.16 6.087-2.16zm35.65 0c2.368 0 4.115.77 5.24 2.308 1.125 1.539 1.392 3.483.8 5.833-.598 2.37-1.856 4.333-3.777 5.891-1.92 1.559-4.04 2.338-6.359 2.338-1.434 0-2.72-.324-3.859-.973-1.138-.65-1.888-1.6-2.25-2.854-.362-1.254-.317-2.78.137-4.58.347-1.376 1.021-2.708 2.024-3.996 1.002-1.288 2.21-2.271 3.624-2.95a10.098 10.098 0 014.42-1.017zM49.751.026l-2.004 7.949c1.73-1.564 3.524-2.345 5.381-2.345.953 0 1.768.177 2.445.53.677.355 1.14.807 1.39 1.358.25.55.361 1.16.335 1.828-.026.669-.216 1.706-.57 3.112l-2.316 9.188h-4.141l2.085-8.274c.414-1.641.598-2.684.552-3.126a1.475 1.475 0 00-.567-1.055c-.332-.26-.798-.39-1.397-.39-.688 0-1.344.167-1.969.501-.625.334-1.147.838-1.567 1.512-.42.673-.797 1.669-1.129 2.986l-1.977 7.846h-4.141L45.609.026h4.142zm46.637 0l-.921 3.657H89.07l-4.527 17.963H80.18l4.527-17.963h-6.41l.921-3.657h17.17zm5.426 5.958l-3.947 15.662h-4.142l3.947-15.662h4.142zm9.74-5.958l-2.892 11.473 6.239-5.515H120l-6.792 5.722 3.228 9.94h-4.465l-2.162-7.035-2.44 2.02-1.264 5.015h-4.141l5.448-21.62h4.142zM68.916 9.007c-1.081 0-2.094.413-3.039 1.239-.945.826-1.613 2.015-2.005 3.569-.391 1.553-.322 2.743.206 3.569.529.826 1.334 1.239 2.415 1.239 1.08 0 2.09-.413 3.03-1.24.941-.825 1.61-2.024 2.006-3.598.386-1.533.318-2.713-.206-3.54-.524-.825-1.326-1.238-2.407-1.238zM102.832 1.943a2.537 2.537 0 01-2.46 1.917h-.187a1.54 1.54 0 01-1.494-1.917 2.537 2.537 0 012.46-1.917h.187a1.54 1.54 0 011.494 1.917z"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M19.934 16.953l-1.227 4.945H6.43l1.239-4.945h12.264zM24.146 0l-1.228 4.945-13.634-.001-4.21 16.954H0L4.204 4.944h-2.31L3.116 0h21.03zM22.04 8.477l-1.227 4.944H8.515l1.23-4.944h12.294z",
    fill: "#655AEC"
  }))));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgLogoText);

/***/ }),

/***/ 91012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74169);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42586);
/* harmony import */ var _react_oauth_google__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86426);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1925);
/* harmony import */ var _utils_gtagEvent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73491);
/* harmony import */ var _useBdVid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63128);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









// Google认证，用于登录/注册/绑定
const useGoogleAuth = props => {
  const {
    onBindSuccess,
    onBindError,
    invite_code
  } = props;
  const {
    qhclickid
  } = (0,_useBdVid__WEBPACK_IMPORTED_MODULE_5__/* .getBdVid */ .Wu)();
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const promotionInfo = (0,_useBdVid__WEBPACK_IMPORTED_MODULE_5__/* .getPromotionInfo */ .yG)();

  const handleSuccess = tokenResponse => {
    setIsLoading(true);
    (0,_api_common__WEBPACK_IMPORTED_MODULE_2__/* .getGoogleInfo */ .Iu)(tokenResponse.access_token).then(res => {
      const userInfo = res === null || res === void 0 ? void 0 : res.data;
      return (0,_api_common__WEBPACK_IMPORTED_MODULE_2__/* .bindAuthApi */ .jQ)('google', _objectSpread({
        id: userInfo === null || userInfo === void 0 ? void 0 : userInfo.sub,
        nickname: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
        name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name,
        email: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email,
        avatar: userInfo === null || userInfo === void 0 ? void 0 : userInfo.picture,
        user: userInfo,
        invite_code
      }, promotionInfo));
    }).then(bindRes => {
      var _bindRes$data;

      setIsLoading(false);

      if ((bindRes === null || bindRes === void 0 ? void 0 : (_bindRes$data = bindRes.data) === null || _bindRes$data === void 0 ? void 0 : _bindRes$data.code) === _utils_constants__WEBPACK_IMPORTED_MODULE_6__/* .SUCCESS_CODE */ .Gh) {
        var _bindRes$data2, _bindRes$data3, _bindRes$data3$data, _bindRes$data4;

        console.log('bindRes?.data?.data', JSON.stringify(bindRes === null || bindRes === void 0 ? void 0 : (_bindRes$data2 = bindRes.data) === null || _bindRes$data2 === void 0 ? void 0 : _bindRes$data2.data));

        if ((bindRes === null || bindRes === void 0 ? void 0 : (_bindRes$data3 = bindRes.data) === null || _bindRes$data3 === void 0 ? void 0 : (_bindRes$data3$data = _bindRes$data3.data) === null || _bindRes$data3$data === void 0 ? void 0 : _bindRes$data3$data.event_type) === 'signup') {
          (0,_utils__WEBPACK_IMPORTED_MODULE_4__/* .baiduRegisterEvent */ .Rk)(); // qhTrackRegister({
          //   qhclickid,
          //   id: bindRes?.data?.data?.user?.user_id
          // })

          (0,_utils_gtagEvent__WEBPACK_IMPORTED_MODULE_7__/* .gtagRegisterEvent */ .IQ)();
        }

        onBindSuccess === null || onBindSuccess === void 0 ? void 0 : onBindSuccess(bindRes === null || bindRes === void 0 ? void 0 : (_bindRes$data4 = bindRes.data) === null || _bindRes$data4 === void 0 ? void 0 : _bindRes$data4.data);
      } else {
        onBindError === null || onBindError === void 0 ? void 0 : onBindError();
      }
    }).catch(() => {
      setIsLoading(false);
    });
  };

  const googleAuth = (0,_react_oauth_google__WEBPACK_IMPORTED_MODULE_3__/* .useGoogleLogin */ .Nq)({
    onSuccess: handleSuccess,
    onError: errorResponse => console.log(errorResponse)
  });
  return {
    googleAuth,
    isLoading
  };
};

/* harmony default export */ __webpack_exports__["Z"] = (useGoogleAuth);

/***/ }),

/***/ 97588:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25617);
/* harmony import */ var _utils_is__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1405);



const useIsMobile = () => {
  var _window;

  const {
    isMobile
  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(state => state.ssr);

  if (!_utils_is__WEBPACK_IMPORTED_MODULE_1__/* .isSSR */ .yF && (_window = window) !== null && _window !== void 0 && _window.navigator.userAgent) {
    var _window2;

    return (0,_utils_is__WEBPACK_IMPORTED_MODULE_1__/* .isMobile */ .tq)((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.navigator.userAgent);
  }

  return isMobile;
};

/* harmony default export */ __webpack_exports__["Z"] = (useIsMobile);

/***/ }),

/***/ 67426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoginBanner; }
/* harmony export */ });
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87629);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83126);
/* harmony import */ var _style_index_module_less__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23876);
/* harmony import */ var _style_index_module_less__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_style_index_module_less__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function LoginBanner() {
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
  const data = [{
    slogan: t['login.banner.slogan1'],
    subSlogan: t['login.banner.subSlogan1'],
    sloganDesc: t['login.banner.sloganDesc1'],
    sloganSubDesc: t['login.banner.sloganSubDesc1'],
    image: 'https://static.echotik.live/banner/login-banner.webp'
  }];
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_3___default().carousel),
    animation: "fade",
    children: data.map((item, index) => /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_3___default()["carousel-column"]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
          className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_3___default()["carousel-item"]) // style={{
          //   background: `url("${item.image}") no-repeat`,
          //   backgroundSize: '100%',
          //   backgroundPosition: 'left bottom'
          // }}
          ,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_3___default()["carousel-title"]),
            children: item.slogan
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_3___default()["carousel-sub-title"]),
            children: item.subSlogan
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_3___default()["carousel-title-desc"]),
            children: item.sloganDesc
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_3___default()["carousel-title-desc"]),
            children: item.sloganSubDesc
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
          alt: "banner-image",
          className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_3___default()["carousel-image"]),
          src: item.image
        })]
      })
    }, `${index}`))
  });
}

/***/ }),

/***/ 29056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PhoneForm; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65976);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80507);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1393);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(79458);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(32403);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(56187);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(77303);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83126);
/* harmony import */ var _utils_useLang__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(877);
/* harmony import */ var _style_index_module_less__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23876);
/* harmony import */ var _style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_style_index_module_less__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useFormLogin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74090);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1925);
/* harmony import */ var ahooks__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75697);
/* harmony import */ var _api_login__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50033);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42586);
/* harmony import */ var _hooks_useSetFormInviteCode__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68275);
/* harmony import */ var _hooks_usePhoneCaptcha__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68638);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);















const initialValues = {
  phone: '',
  code: '',
  invite_code: ''
};
function PhoneForm(_ref) {
  let {
    onChangeForm
  } = _ref;
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
  const [form] = _arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"].useForm */ .Z.useForm();
  const {
    0: targetDate,
    1: setTargetDate
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  const [countdown] = (0,ahooks__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
    targetDate,
    onEnd: () => {// setIsButtonDisabled(false)
    }
  });
  const {
    0: smsBtnLoading,
    1: setSmsBtnLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const isButtonDisabled = countdown !== 0;
  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
  const isLogin = router.pathname.indexOf('/login') > -1;
  const event = isLogin ? 'login' : 'signup';
  const lang = (0,_utils_useLang__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const isEnglish = lang === 'en-US';
  const {
    onPhoneSubmitClick,
    loading
  } = (0,_hooks_useFormLogin__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    form
  });
  (0,_hooks_useSetFormInviteCode__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    form
  });

  const handleGetCode = async () => {
    try {
      await form.validate(['phone']);
      setSmsBtnLoading(true);
      const {
        phone
      } = form.getFields(); // 发送短信

      (0,_api_login__WEBPACK_IMPORTED_MODULE_6__/* .postSmsApi */ .dE)({
        phone: phone,
        event: event
      }).then(res => {
        var _res$data;

        if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === _utils_constants__WEBPACK_IMPORTED_MODULE_12__/* .SUCCESS_CODE */ .Gh) {
          setTargetDate(Date.now() + 60000);
          _arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"].success */ .Z.success(t['sms_success']);
        } else {
          _arco_design_web_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"].error */ .Z.error(t['sms_error']);
        }
      }).finally(() => {
        setSmsBtnLoading(false);
      });
    } catch (e) {
      console.log('catch phone error:', e);
      return;
    }
  };

  const {
    onCaptchaShow
  } = (0,_hooks_usePhoneCaptcha__WEBPACK_IMPORTED_MODULE_8__/* .usePhoneCaptcha */ .i)(form, handleGetCode);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
    className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default()["login-form-wrapper"]),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      form: form,
      className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default()["login-form"]),
      layout: "vertical",
      initialValues: initialValues,
      size: "large",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Item */ .Z.Item, {
        label: t['phone_number'],
        field: "phone",
        validateTrigger: ['onFinish'],
        rules: [{
          required: true,
          validator: _utils__WEBPACK_IMPORTED_MODULE_5__/* .phoneFormValidator */ .ht,
          message: t['login.form.phone.errMsg']
        }],
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
          size: "large",
          className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default().customInput),
          addBefore: "+86",
          placeholder: t['phone_number']
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Item */ .Z.Item, {
        label: t['verification_code'],
        required: true,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_16__/* ["default"].Row */ .Z.Row, {
          align: "center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Item */ .Z.Item, {
            noStyle: {
              showErrorTip: true
            },
            field: "code",
            rules: [{
              required: true,
              message: t['code_errMsg']
            }],
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
              size: "large",
              className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default().customInput),
              hideControl: true,
              placeholder: t['verification_code'],
              min: 0,
              style: {
                flex: 1
              }
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
            type: "primary",
            onClick: onCaptchaShow,
            disabled: isButtonDisabled || smsBtnLoading,
            size: "large",
            style: {
              height: 46
            },
            id: "captcha-button",
            className: "captcha-btn",
            children: isButtonDisabled ? `${Math.round(countdown / 1000)}s ${t['get_verification_code']}` : t['get_verification_code']
          })]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Item */ .Z.Item, {
        label: t['register.form.invite.label'],
        field: "invite_code",
        validateTrigger: ['onFinish'] // rules={[{ required: true, validator: phoneFormValidator, message: t['login.form.phone.errMsg'] }]}
        ,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
          size: "large",
          className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default().customInput),
          placeholder: t['register.form.invite.placeholder']
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
        size: 16,
        direction: "vertical",
        children: [isLogin ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
          className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default().emailLogin),
          onClick: () => onChangeForm === null || onChangeForm === void 0 ? void 0 : onChangeForm('email'),
          children: t['email_login']
        }) : isEnglish ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
          className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default().emailLogin),
          onClick: () => onChangeForm === null || onChangeForm === void 0 ? void 0 : onChangeForm('email'),
          children: t['email_register']
        }) : null, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
          type: "primary",
          long: true,
          onClick: onPhoneSubmitClick,
          loading: loading,
          className: (_style_index_module_less__WEBPACK_IMPORTED_MODULE_14___default()["login-form-btn"]),
          children: t['login_register']
        })]
      })]
    })
  });
}

/***/ }),

/***/ 19959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WeChatLogin; }
/* harmony export */ });
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _api_login__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50033);
/* harmony import */ var _hooks_useAfterLogin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48059);
/* harmony import */ var _hooks_useAfterOnboarding__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30473);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80507);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(62258);
/* harmony import */ var _arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(56187);
/* harmony import */ var _assets_icon_refresh_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83518);
/* harmony import */ var _arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(81025);
/* harmony import */ var _utils_useLang__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(877);
/* harmony import */ var _utils_useLocale__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83126);
/* harmony import */ var _style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(7353);
/* harmony import */ var _style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_checkLogin__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23199);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1925);
/* harmony import */ var _hooks_useBdVid__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63128);
/* harmony import */ var _utils_gtagEvent__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(73491);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















function WeChatLogin(props) {
  var _router$query;

  const router = (0,next_router__WEBPACK_IMPORTED_MODULE_8__.useRouter)();
  const initQrcodeUrl = ((_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.qrcodeUrl) || '';
  const {
    qhclickid
  } = (0,_hooks_useBdVid__WEBPACK_IMPORTED_MODULE_11__/* .getBdVid */ .Wu)();
  const promotionInfo = (0,_hooks_useBdVid__WEBPACK_IMPORTED_MODULE_11__/* .getPromotionInfo */ .yG)();
  const {
    type,
    step,
    setStep,
    sessionFlag,
    setSessionFlag,
    inviteCode
  } = props;
  const {
    0: qrcodeUrl,
    1: setQrcodeUrl
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initQrcodeUrl); // const [sessionFlag, setSessionFlag] = useState('')

  const {
    0: isExpire,
    1: setIsExpire
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const {
    0: isAgree,
    1: setIsAgree
  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const lang = (0,_utils_useLang__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)();
  const t = (0,_utils_useLocale__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
  const checkId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  const {
    afterLoginSuccess
  } = (0,_hooks_useAfterLogin__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    rememberPassword: false
  });
  const {
    afterRegisterSuccess
  } = (0,_hooks_useAfterOnboarding__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    rememberPassword: false
  });

  const fetchQrcode = async () => {
    var _res$data;

    setIsLoading(true);
    const res = await (0,_api_login__WEBPACK_IMPORTED_MODULE_2__/* .getWeChatQrcode */ .yd)();

    if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.data) {
      var _res$data2;

      const {
        session_flag,
        url
      } = (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data) || {};
      url && setQrcodeUrl(url);
      session_flag && setSessionFlag(session_flag);
      setTimeout(() => {
        setIsExpire(true);
        checkId.current && clearTimeout(checkId.current);
      }, 300000);
    }

    setIsLoading(false);
  };

  const checkBind = async () => {
    var _res$data3, _res$data3$data;

    const res = await (0,_api_login__WEBPACK_IMPORTED_MODULE_2__/* .checkWeChatBind */ .t4)(_objectSpread(_objectSpread({
      session_flag: sessionFlag,
      invite_code: inviteCode
    }, promotionInfo), {}, {
      debug: true
    }));

    if (res !== null && res !== void 0 && (_res$data3 = res.data) !== null && _res$data3 !== void 0 && (_res$data3$data = _res$data3.data) !== null && _res$data3$data !== void 0 && _res$data3$data.access_token) {
      var _res$data4, _res$data5, _res$data5$data, _res$data6, _res$data6$data, _res$data6$data$user, _res$data7, _res$data7$data, _res$data7$data$user;

      // 登录成功
      (0,_utils_checkLogin__WEBPACK_IMPORTED_MODULE_9__/* .clearInviteCode */ .E$)();
      checkId.current && clearTimeout(checkId.current);
      console.log('res?.data?.data', JSON.stringify(res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.data));

      if ((res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : (_res$data5$data = _res$data5.data) === null || _res$data5$data === void 0 ? void 0 : _res$data5$data.event_type) === 'signup') {
        (0,_utils__WEBPACK_IMPORTED_MODULE_10__/* .baiduRegisterEvent */ .Rk)(); // qhTrackRegister({
        //   qhclickid,
        //   id: res?.data?.data?.user?.user_id
        // })

        (0,_utils_gtagEvent__WEBPACK_IMPORTED_MODULE_13__/* .gtagRegisterEvent */ .IQ)();
      }

      if ((res === null || res === void 0 ? void 0 : (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : (_res$data6$data = _res$data6.data) === null || _res$data6$data === void 0 ? void 0 : (_res$data6$data$user = _res$data6$data.user) === null || _res$data6$data$user === void 0 ? void 0 : _res$data6$data$user.region) === null || (res === null || res === void 0 ? void 0 : (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : (_res$data7$data = _res$data7.data) === null || _res$data7$data === void 0 ? void 0 : (_res$data7$data$user = _res$data7$data.user) === null || _res$data7$data$user === void 0 ? void 0 : _res$data7$data$user.region) === null) {
        afterRegisterSuccess('', res === null || res === void 0 ? void 0 : res.data);
      } else {
        _arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"].success */ .Z.success(t['login.wechat.success']);
        afterLoginSuccess({}, res === null || res === void 0 ? void 0 : res.data);
      }
    } else {
      checkId.current = setTimeout(checkBind, 3000);
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (step === '') {
      fetchQrcode();
    }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    if (qrcodeUrl && sessionFlag) {
      checkId.current = setTimeout(checkBind, 3000);
    }

    return () => {
      checkId.current && clearTimeout(checkId.current);
    };
  }, [qrcodeUrl, sessionFlag]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
    style: {
      width: '370px'
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
      loading: isLoading,
      style: {
        height: '258px',
        width: '258px',
        marginBottom: '32px'
      },
      children: [isExpire && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
        className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_16___default()["expire-wrap"]),
        onClick: () => {
          fetchQrcode();
          setIsExpire(false);
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
          className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_16___default().expire),
          children: ["\u4E8C\u7EF4\u7801\u5DF2\u5931\u6548", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_assets_icon_refresh_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_16___default().refresh)
          })]
        })
      }), step === 'complete' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_16___default().next),
        children: ["\u5FAE\u4FE1\u5DF2\u7ED1\u5B9A", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_arco_design_web_react__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
          onClick: () => {
            if (!isAgree) {
              _arco_design_web_react__WEBPACK_IMPORTED_MODULE_14__/* ["default"].error */ .Z.error('请先阅读并同意服务协议和隐私协议！');
              return;
            } // 不再校验验证码
            // if (!isEffective) {
            //   Message.error('请输入有效的邀请码！')
            //   return
            // }


            setStep('fulfill');
          },
          className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_16___default()["next-btn"]),
          children: "\u4E0B\u4E00\u6B65"
        })]
      }), qrcodeUrl && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
        style: {
          width: '258px',
          height: '258px'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("img", {
          src: qrcodeUrl,
          className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_16___default().qrcode)
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_arco_design_web_react_icon__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
          style: {
            color: '#00C800',
            marginRight: '10px',
            width: '32px',
            height: '32px'
          }
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
        style: {
          color: '#403D5A',
          marginRight: '39px'
        },
        children: type === 'register' ? t['register.wechat.scan'] : t['login.wechat.scan']
      })]
    }), type === 'register' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
      style: {
        marginTop: '32px'
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("span", {
        className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_16___default()["checkbox-text"]),
        children: [t['register.scan.tip'], /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("a", {
          href: "https://echotik.live/privacy-policy.html",
          target: "_blank",
          rel: "noreferrer",
          className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_16___default()["checkbox-protocol"]),
          children: t['register.service.term']
        }), t['register.and'], /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("a", {
          href: "https://echotik.live/privacy-policy.html",
          target: "_blank",
          rel: "noreferrer",
          className: (_style_wechat_login_module_less__WEBPACK_IMPORTED_MODULE_16___default()["checkbox-protocol"]),
          children: t['register.privacy.policy']
        })]
      })
    })]
  });
}

/***/ }),

/***/ 23876:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__HEtnF","banner":"index_banner__wHL5t","content":"index_content__sbVqm","footer":"index_footer__Zylz_","logo":"index_logo___Rv91","logo-text":"index_logo-text__JwWIf","banner-inner":"index_banner-inner__UGMWN","contentHeader":"index_contentHeader__DNSks","headerLink":"index_headerLink__n6vjk","carousel":"index_carousel__E4O9M","carousel-item":"index_carousel-item__3VMDq","carousel-title":"index_carousel-title__5clYN","carousel-sub-title":"index_carousel-sub-title__iv0Mf","carousel-title-desc":"index_carousel-title-desc__jgsIE","carousel-column":"index_carousel-column__zkIrT","carousel-image":"index_carousel-image__2uazI","login-form-wrapper":"index_login-form-wrapper__B6CxZ","login-form-title":"index_login-form-title__GRfkh","login-form-sub-title":"index_login-form-sub-title__sMBc6","login-form-error-msg":"index_login-form-error-msg__J4NB1","login-form-password-actions":"index_login-form-password-actions__lsQOS","login-form-btn":"index_login-form-btn__cHTuk","login-form-register-btn":"index_login-form-register-btn__HT9U3","title":"index_title__qfvdE","succeed":"index_succeed__xMjJi","icon":"index_icon__pHFp6","customInput":"index_customInput__6_6wA","emailLogin":"index_emailLogin__yVfWT"};

/***/ }),

/***/ 7353:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"next":"wechat-login_next__oeJA2","next-btn":"wechat-login_next-btn__xZLh5","expire-wrap":"wechat-login_expire-wrap__ec_7S","expire":"wechat-login_expire__Esh0T","refresh":"wechat-login_refresh__0lab_","qrcode":"wechat-login_qrcode__cnvM2","logo":"wechat-login_logo__ReHyw","checkbox":"wechat-login_checkbox__LD9ND","checkbox-text":"wechat-login_checkbox-text__wss7z","checkbox-protocol":"wechat-login_checkbox-protocol__4YbAd"};

/***/ })

}]);